import React from 'react';
import PropTypes from 'prop-types';
import SelectField from '../SelectField';

const LanguagesSelect = (props) => {
  const {
    languages,
    onFieldChange,
    values,
  } = props;

  return (
    <div className="uu-languages-select">
      <label htmlFor="uu-languages">
        Languages
      </label>
      <SelectField
        id="uu-languages"
        name="languages"
        value={values.languages}
        onChange={onFieldChange}
        multiple
        options={languages}
      />
    </div>
  );
};

LanguagesSelect.propTypes = {
  languages: PropTypes.array.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default LanguagesSelect;



// WEBPACK FOOTER //
// ./public/js/components/Search/LanguagesSelect.jsx